export * from "./ThankYou";
